export default "__VITE_ASSET__BUzTzg$W__"